export const MENU_PERMISSIONS = {
  seleccionarPV: 'SeleccionarPV',
  adminRegistro: 'AdminRegistro',
  aplicaciones: 'Aplicaciones',
  consultaCorreccion: 'ConsultaCorreccion',
  consultaDevoluciones: 'ConsultaDevoluciones',
  rolesGrupos: 'RolesGrupos',
  correccionExistencia: 'CorreccionExistencia',
  dashboardSeguridad: 'DashboardSeguridad',
  rolPermiso: 'RolPermiso',
  grupos: 'Grupos',
  mantenimientoCatalogos: 'MantenimientoCatalogos',
  permisos: 'Permisos',
  promocionCupones: 'PromocionCupones',
  promocionPromocionales: 'PromocionPromocionales',
  roles: 'Roles',
  sociedades: 'Sociedades',
  tipoAcceso: 'TipoAcceso',
  usuarios: 'Usuarios',
  tipoAccesoUsuarios: 'TipoAccesoUsuarios',
  rolesUsuarios: 'RolesUsuarios',
  promocionXXYPT: 'PromocionXXYPT',
  promocionXXYSM: 'PromocionXXYSM',
  exclusivos: 'Exclusivos',
  esencias: 'Esencias',
  semiterminados: 'SemiterminadosAsistente',
  productoTerminado: 'ProductoTerminado',
  categorias: 'Categorias',
  familiaOlfativa: 'FamiliaOlfativa',
  kits: 'AsistenteKits',
  mantenimientoProducto: 'MantenimientoProducto',
  aumentaConsecutivoNota: 'AumentaConsecutivoNota',
  perfumol: 'Perfumol',
  accesorios: 'Accesorios',
  capacidades: 'Capacidades'
} as const;

export const CORPORATE_MENU_PERMISSIONS = new Set<string>(
  Object.values(MENU_PERMISSIONS)
);
